import { AxiosResponse } from 'axios';
import { Store } from 'redux';
import { logger } from 'logging';
import {
  ADD_TO_CART_REFRESH_REQUEST_PATH,
  ADD_TO_CART_REQUEST_PATH,
  CART_LITE_API,
} from 'store/addToCart/constants';
import API_ENDPOINTS from '@nykaa/cart-shared/store/constants/endpoint';
import { getEligibleForVariant } from 'helpers/experimentV2';
import { State } from 'store/types';
import { CART_STEP_COUNTER } from 'constants/experiments';
import { CartItem } from 'store/addToCart/types';
import { isValidArrayLength } from '@nykaa/utils/validations';
import { updateCartProductQuantities } from 'store/auth/action';

const {
  REMOVE_PRODUCTS,
  UPDATE_QUANTITY,
  ADD_ITEM_TO_CART,
  ADD_ITEM_TO_CART_V1,
  CART_REFRESH,
} = API_ENDPOINTS;

const CART_API_ENDPOINTS = [
  ADD_TO_CART_REFRESH_REQUEST_PATH,
  ADD_TO_CART_REQUEST_PATH,
  CART_LITE_API,
  REMOVE_PRODUCTS,
  UPDATE_QUANTITY,
  ADD_ITEM_TO_CART,
  ADD_ITEM_TO_CART_V1,
  CART_REFRESH,
];

const isCartApiEndpoint = (url: string): boolean =>
  CART_API_ENDPOINTS.some((endpoint) => url.includes(endpoint));

const extractProductQuantities = (
  items: CartItem[]
): Record<string, number> => {
  const productQuantities: Record<string, number> = {};

  if (!isValidArrayLength(items)) {
    return productQuantities;
  }

  items.forEach((item) => {
    const productId = item?.id || item?.productId;
    const quantity = item?.quantity || 0;

    if (productId) {
      productQuantities[productId] = quantity;
    }
  });

  return productQuantities;
};

export const cartResponseInterceptor =
  (store: Store<State>) => (response: AxiosResponse) => {
    const state = store.getState();
    const cartQuantityExpEnabled = getEligibleForVariant(
      state,
      CART_STEP_COUNTER,
      'A'
    );

    const { stepperEnabled } =
      state?.remoteConfig?.configs?.productRackConfig || {};
    const isCartQuantityExpEnabled = cartQuantityExpEnabled || stepperEnabled;

    if (!isCartQuantityExpEnabled) {
      return response;
    }

    try {
      const url = response.config.url || '';
      if (isCartApiEndpoint(url)) {
        const { data } = response || {};
        const { data: cartData } = data || {};
        const { items } = cartData || {};

        if (items && Array.isArray(items)) {
          const productQuantities = extractProductQuantities(items);
          store.dispatch(updateCartProductQuantities(productQuantities));
        }
      }
    } catch (error) {
      logger.error(error as Error, 'Error in cart response interceptor');
    }

    return response;
  };

export const cartErrorInterceptor = (error: any) => Promise.reject(error);
